var exports = {
  "R": "xfd349460--c57cda--heading",
  "Q": "xfd349460--c57cda--content",
};

module.exports = exports;
